import React, { useEffect, useState } from 'react';
import {
  Box,
  Typography,
  Switch,
  Button,
  styled,
  CircularProgress,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions
} from '@mui/material';
import UserSettingsAPI from '../../utilities/api/user/UserSettingsAPI';
import { notifyError, notifySuccess } from '../../utils/notifyToasts';
import { useDispatch, useSelector } from 'react-redux';
import { logoutUser } from '../../redux/slices/userSlice';

const CustomSwitch = styled(Switch)(({ theme }) => ({
  width: 44,
  height: 24,
  padding: 0,
  display: 'flex',
  '&:active': {
    '& .MuiSwitch-thumb': {
      width: 20,
    },
    '& .MuiSwitch-switchBase.Mui-checked': {
      transform: 'translateX(18px)',
    },
  },
  '& .MuiSwitch-switchBase': {
    padding: 2,
    '&.Mui-checked': {
      transform: 'translateX(20px)',
      color: '#fff',
      '& + .MuiSwitch-track': {
        opacity: 1,
        backgroundColor: '#139C32',
      },
    },
  },
  '& .MuiSwitch-thumb': {
    boxShadow: '0 2px 4px 0 rgb(0 35 11 / 20%)',
    width: 20,
    height: 20,
    borderRadius: 10,
    transition: theme.transitions.create(['width'], {
      duration: 200,
    }),
  },
  '& .MuiSwitch-track': {
    borderRadius: 24 / 2,
    opacity: 1,
    backgroundColor: '#E0E0E0',
    boxSizing: 'border-box',
  },
}));

const SettingRow = ({ title, subtitle, checked, onChange, name, disabled }) => (
  <Box sx={{ display: 'flex', alignItems: 'center', mb: 4 }}>
    <Box sx={{ width: { xs: '200px', md: '300px' }, textAlign: 'left', mr: 2 }}>
      <Typography sx={{ color: '#3F3F3F', fontSize: '15px', fontWeight: 600, mb: 0.5 }}>
        {title}
      </Typography>
      <Typography sx={{ color: '#8A8A8A', fontSize: '14px' }}>
        {subtitle}
      </Typography>
    </Box>
    <CustomSwitch checked={checked} onChange={onChange} name={name} disabled={disabled} />
  </Box>
);

const PrivacyContainer = () => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(true);
  const [state, setState] = useState({
    discoverability: true,
    profile_avatar_visibility: false,
  });

  const { user } = useSelector((state) => state.user || {});
  const [openModal, setOpenModal] = useState(false);
  const [deleting, setDeleting] = useState(false);

  useEffect(() => {
    fetchSettings();
  }, [user?.user?.TL_name]);

  const fetchSettings = async () => {
    try {
      setLoading(true);
      const res = await UserSettingsAPI.getSettings();
      setState({
        discoverability: res.data.discoverability,
        profile_avatar_visibility: res.data.profile_avatar_visibility,
      });
    } catch (error) {
      notifyError('Failed to load settings');
    } finally {
      setLoading(false);
    }
  };

  const handleToggle = async (event) => {
    const { name, checked } = event.target;
    // Optimistic update
    setState((prevState) => ({ ...prevState, [name]: checked }));

    try {
      await UserSettingsAPI.updateSettings({ [name]: checked });
      notifySuccess('Setting updated');
    } catch (error) {
      notifyError('Failed to update setting');
      // Revert on error
      setState((prevState) => ({ ...prevState, [name]: !checked }));
    }
  };

  const handleDeleteAccount = async () => {
    try {
      setDeleting(true);
      await UserSettingsAPI.deleteAccount();
      notifySuccess('Account deleted successfully');
      setOpenModal(false);
      dispatch(logoutUser());
    } catch (error) {
      notifyError('Failed to delete account');
      setDeleting(false);
    }
  };

  if (loading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', p: 4 }}>
        <CircularProgress />
      </Box>
    );
  }

  return (
    <Box
      sx={{
        bgcolor: 'background.paper',
        p: { xs: 2, md: 4 },
        border: '1px solid #E0E0E0',
        borderRadius: '8px',
        mt: 2,
        width: '100%',
        boxSizing: 'border-box',
        textAlign: 'left'
      }}
    >
      <SettingRow
        title="Discoverability"
        subtitle="Allow users to find you by your Email ID or Phone Number"
        name="discoverability"
        checked={state.discoverability}
        onChange={handleToggle}
      />

      {/* <SettingRow
        title="Profile Avatar visibility"
        subtitle="Allow users to view your actual name and profile picture"
        name="profile_avatar_visibility"
        checked={state.profile_avatar_visibility}
        onChange={handleToggle}
      /> */}
    </Box>
  );
};

export default PrivacyContainer;
